import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import {WelcomePage} from "../pages/welcome/welcome";
import {BiblioPage} from "../pages/biblio/biblio";
import {AcknowledgmentsPage} from "../pages/acknowledgments/acknowledgments";
import {AdminLoginPage} from "../pages/admin-login/admin-login";
import {AdminHomePage} from "../pages/admin-home/admin-home";
import {ServicesModule} from "../services/services.module";
import {InsertPatientDataPage} from "../pages/insert-patient-data/insert-patient-data";
import {MailLoginPage} from "../pages/mail-login/mail-login";
import {ResultsPage} from "../pages/results/results";
import {AngularFireModule} from "angularfire2";
import {AngularFireAuthModule} from "angularfire2/auth";
import {AngularFirestoreModule} from "angularfire2/firestore";
import {firebaseConfig} from "../firebase.config";
import {AdminBiblioPage} from "../pages/admin-biblio/admin-biblio";
import {AdminAcknowledgmentsPage} from "../pages/admin-acknowledgments/admin-acknowledgments";
import {AdminEmailsPage} from "../pages/admin-emails/admin-emails";
import {AdminWelcomePage} from "../pages/admin-welcome/admin-welcome";
import {IonicStorageModule} from "@ionic/storage";
import {ComponentsModule} from "../components/components.module";
import {OverviewResultsPage} from "../pages/overview-results/overview-results";
import {ClipboardModule} from "ngx-clipboard";
import {QuillModule} from "ngx-quill";
import {AdminConfigPage} from "../pages/admin-config/admin-config";
import {UsagePage} from "../pages/usage/usage";
import {AdminUsagePage} from "../pages/admin-usage/admin-usage";
import {WelcomePageModule} from "../pages/welcome/welcome.module";
import {AdminLoginPageModule} from "../pages/admin-login/admin-login.module";
import {InsertPatientDataPageModule} from "../pages/insert-patient-data/insert-patient-data.module";
import {MailLoginPageModule} from "../pages/mail-login/mail-login.module";
import {UsagePageModule} from "../pages/usage/usage.module";
import {AdminConfigPageModule} from "../pages/admin-config/admin-config.module";
import {OverviewResultsPageModule} from "../pages/overview-results/overview-results.module";
import {ResultsPageModule} from "../pages/results/results.module";
import {AdminUsagePageModule} from "../pages/admin-usage/admin-usage.module";
import {AdminEmailsPageModule} from "../pages/admin-emails/admin-emails.module";
import {AdminAcknowledgmentsPageModule} from "../pages/admin-acknowledgments/admin-acknowledgments.module";
import {AdminWelcomePageModule} from "../pages/admin-welcome/admin-welcome.module";
import {AdminBiblioPageModule} from "../pages/admin-biblio/admin-biblio.module";
import {AdminHomePageModule} from "../pages/admin-home/admin-home.module";
import {BiblioPageModule} from "../pages/biblio/biblio.module";
import {AcknowledgmentsPageModule} from "../pages/acknowledgments/acknowledgments.module";

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp,
      {
        backButtonText: ' ',
        pageTransition: 'ios-transition',
        mode: 'ios'
      },
      {
        links: [
          {component: AdminLoginPage , name: 'AdminLogin', segment: 'admin-login' },
          {component: AdminHomePage , name: 'AdminHome', segment: 'admin-home' },
          {component: WelcomePage , name: 'Welcome', segment: 'welcome' },
          {component: InsertPatientDataPage , name: 'InsertPatientData', segment: 'patient-data' },
          {component: ResultsPage , name: 'Results', segment: 'results' },
          {component: OverviewResultsPage , name: 'OverviewResults', segment: 'overview-results' },
          {component: AcknowledgmentsPage , name: 'Acknowledgments', segment: 'acknowledgments' },
          {component: BiblioPage , name: 'Biblio', segment: 'biblio' },
          {component: MailLoginPage , name: 'MailLogin', segment: 'login' },
          {component: UsagePage , name: 'Usage', segment: 'usage' },
        ]
      }),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    ServicesModule,
    IonicStorageModule.forRoot(),
    ComponentsModule,
    ClipboardModule,
    QuillModule,
    WelcomePageModule,
    BiblioPageModule,
    AcknowledgmentsPageModule,
    AdminLoginPageModule,
    AdminHomePageModule,
    AdminBiblioPageModule,
    AdminWelcomePageModule,
    AdminAcknowledgmentsPageModule,
    AdminEmailsPageModule,
    AdminUsagePageModule,
    InsertPatientDataPageModule,
    MailLoginPageModule,
    ResultsPageModule,
    OverviewResultsPageModule,
    AdminConfigPageModule,
    UsagePageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    WelcomePage,
    BiblioPage,
    AcknowledgmentsPage,
    AdminLoginPage,
    AdminHomePage,
    AdminBiblioPage,
    AdminUsagePage,
    AdminAcknowledgmentsPage,
    AdminEmailsPage,
    AdminWelcomePage,
    InsertPatientDataPage,
    MailLoginPage,
    ResultsPage,
    OverviewResultsPage,
    AdminConfigPage,
    UsagePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts